import useCanManageStackRoleBindings from "shared/Stack/access/useCanManageStackRoleBindings";
import useTypedContext from "hooks/useTypedContext";
import { StackRoleBindingView } from "shared/Stack/Roles/types";
import { useBulkStackRoleBindingDelete } from "shared/Stack/Roles/useStackRoleBindingDelete";

import { StackRolesBulkActions, StackRolesBulkActionItem } from "../types";
import { StackSettingsContextData } from "../../../Context";

const useUnassignStackRolesBulkAction = (): StackRolesBulkActionItem => {
  const { stackSettings } = useTypedContext(StackSettingsContextData);
  const [deleteStackRoleBinding] = useBulkStackRoleBindingDelete();
  const canManageStackRoleBindings = useCanManageStackRoleBindings();

  return {
    key: StackRolesBulkActions.Unassign,
    title: "Unassign",
    resultTitle: "Unassign roles results",
    condition: () => canManageStackRoleBindings(stackSettings),
    mutation: (roleBinding: StackRoleBindingView) => deleteStackRoleBinding({ id: roleBinding.id }),
  };
};

export default useUnassignStackRolesBulkAction;
